import React, { useState } from 'react';
import theme from './BuyerOfferLineGroupDisplay.module.scss';
import { BuyerOfferLineGroup } from '@/types';
import { PriceDisplay, FeeSetConnectionInfoDisplay } from '../fees';
import ProfileAndUserDisplay from '@/components/ProfileAndUserDisplay';
import BuyerOfferAttachmentList from './BuyerOfferAttachmentList';
import { Trans } from '@lingui/react/macro';
import { ExpandableCard, CardSection, ExpandableCardHandle } from '@/components/Cards';
interface BuyerOfferGroupDisplayProps {
    lineGroup: BuyerOfferLineGroup;
}

const BuyerOfferLineGroupDisplay: React.FC<BuyerOfferGroupDisplayProps> = ({ lineGroup }) => {
    const [expanded, setExpanded] = useState(false);

    const renderDetails = () => {
        return (
            <>
                {lineGroup.note && (
                    <div className={theme.detailsSection}>
                        <h6>
                            <Trans>Note</Trans>
                        </h6>
                        {lineGroup.note}
                    </div>
                )}

                {lineGroup.offerLines && lineGroup.offerLines.length > 0 && (
                    <div className={theme.detailsSection}>
                        <h6>
                            <Trans>Price breakdown</Trans>
                        </h6>
                        <table className="table style-3">
                            <thead>
                                <tr>
                                    <th>
                                        <Trans>Description</Trans>
                                    </th>
                                    <th className="nowrap">
                                        <Trans>Fees</Trans>
                                    </th>
                                    <th className="nowrap text-right">
                                        <Trans>Amount</Trans>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {lineGroup.offerLines.map((line) => (
                                    <tr key={line.id}>
                                        <td>{line.description}</td>
                                        <td className="nowrap">
                                            {line.feeSetInfo ? (
                                                <FeeSetConnectionInfoDisplay value={line.feeSetInfo} />
                                            ) : (
                                                <Trans>Redacted</Trans>
                                            )}
                                        </td>
                                        <td className="nowrap text-right">
                                            <PriceDisplay value={line} redacted={lineGroup.priceRedacted} hideInfoIcon />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={2}>
                                        <Trans>Subtotal</Trans>
                                    </th>
                                    <th className="text-right">
                                        <PriceDisplay
                                            value={{
                                                basePrice: lineGroup.totalBasePrice,
                                                finalPrice: lineGroup.totalFinalPrice,
                                            }}
                                            redacted={lineGroup.priceRedacted}
                                        />
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                )}

                {lineGroup.attachments.length > 0 && (
                    <div className={theme.detailsSection}>
                        <h6>
                            <Trans>Attachments</Trans>
                        </h6>
                        <BuyerOfferAttachmentList
                            value={lineGroup.attachments}
                            showVisibilityFlags
                            canAdd={false}
                            canEdit={false}
                            ownerProfileId={lineGroup.providedByProfileId}
                        />
                    </div>
                )}
            </>
        );
    };

    return (
        <ExpandableCard expanded={expanded} expandableContent={renderDetails()} type="inside-bordered">
            <ProfileAndUserDisplay
                userId={lineGroup.providedByUserId}
                userName={lineGroup.providedByUserName}
                profileId={lineGroup.providedByProfileId}
                profileName={lineGroup.providedByProfileName}
            />

            <CardSection caption={<Trans>Subtotal</Trans>} className="text-right" right>
                <PriceDisplay
                    value={{ basePrice: lineGroup.totalBasePrice, finalPrice: lineGroup.totalFinalPrice }}
                    redacted={lineGroup.priceRedacted}
                />
            </CardSection>

            <ExpandableCardHandle onExpandToggle={setExpanded} expanded={expanded} />
        </ExpandableCard>
    );
};

export default BuyerOfferLineGroupDisplay;
